<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Administração"
            description="Configurações necessárias"
            url="/dashboard"
          />
        </div>
      </div>
      <div class="grid-itens">
        <div v-for="(item, index) in cards" :key="index" class="item-flex">
          <router-link v-if="item != false" :to="item.link">
            <div class="item">
              <i v-if="item.icone !== false" :class="item.icone"></i>
              <img v-else :src="item.imagem" alt="" />
              <h3>
                {{ item.titulo }}
              </h3>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import { mapState } from 'vuex'

export default {
  name: 'AdministracaoIndex',
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
  computed: {
    ...mapState(['id_funcao']),
    cards() {
      const cards = this.$store.state?.permissoes?.administracao
      let data = cards.map((element) => {
        if (
          this.$store.state.infoMunicipio.exibe_logoefb == '1' &&
          element.key == 'gerenciar_logotipo'
        ) {
          return false
        }
        return {
          ...element,
        }
      })
      return data.filter((el) => el != false)
    },
  },
  data() {
    return {}
  },
}
</script>

<style>
.link {
  border: 0;
  display: block;
  width: 100%;
  font-size: 14px;
  padding: 0 60px 0 20px;
  font-weight: 400;
  color: #999;
  border-radius: 3px;
  background: #fff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  padding: 15px;
  margin-top: 20px;
}
.link b {
  color: #000;
}
.step iframe {
  margin: 20px auto;
  display: block;
}

@media (max-width: 768px) {
  .step iframe {
    width: 100% !important;
  }
  .link {
    margin-bottom: 0px;
  }
  .link a {
    word-break: break-all;
  }
}
</style>
